import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from '@angular/router';

export class NoReuseStrategy implements RouteReuseStrategy {
    shouldDetach(_route: ActivatedRouteSnapshot): boolean {
        return false;
    }
    store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {
        // Intentionally empty because we do not store routes
    }
    shouldAttach(_route: ActivatedRouteSnapshot): boolean {
        return false;
    }
    retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        return null;
    }
    shouldReuseRoute(_future: ActivatedRouteSnapshot, _curr: ActivatedRouteSnapshot): boolean {
        return false; // always destroy & recreate component
    }
}
